import React from "react";
import MDButton from "components/MDButton";
import Link from "@mui/material/Link";

const sizeStyles = {
  small: {
    fontSize: "12px",
    padding: "10px 16px",
  },
  medium: {
    fontSize: "14px",
    padding: "11px 20px",
  },
  large: {
    fontSize: "16px",
    padding: "12px 24px",
  },
};

const typeStyles = {
  primary: {
    color: "#fff",
    backgroundColor: "#ff2c56",
    transition: "background-color .15s ease-in",
    borderRadius: ".9rem",
    padding: ".5rem 1rem",
    fontWeight: 600,
    lineHeight: "1.75rem",
    width: "100%",
    "&:hover": {
      color: "#fff",
      backgroundColor: "#ff2c56",
      borderColor: "black",
    },
  },
  secondary: {
    color: "#fbfbfb",
    backgroundColor: "#909090",
    transition: "background-color .15s ease-in",
    borderRadius: ".9rem",
    padding: ".5rem 1rem",
    fontWeight: 600,
    lineHeight: "1.75rem",
    width: "100%",
    "&:hover": {
      color: "#fff",
      backgroundColor: "#909090",
    },
  },
};

const BaseButton = ({ label, href, onClick, type = "primary", size = "medium", sx = {} }) => (
  <Link href={href} target="_blank">
    <MDButton
      color={type}
      size={size}
      onClick={onClick}
      sx={{ ...sizeStyles[size], ...typeStyles[type], ...sx }}
    >
      {label}
    </MDButton>
  </Link>
);

export default BaseButton;
